/* eslint-disable @typescript-eslint/no-namespace */
// logger.ts
import logger from "electron-log/renderer";

declare global {
  const log: typeof logger;
  interface Window {
    log: typeof logger;
  }
}

const _self = window;

_self.log = logger;

if (
  process.env.VUE_APP_ENV === "production" ||
  process.env.VUE_APP_ENV === "test"
) {
  logger.transports.console.level = false;
} else {
  logger.transports.console.level = "silly";
}

window.onerror = (message, source, lineno, colno, error) => {
  logger.error("[window.onerror]", {
    message: message,
    source: source,
    lineno: lineno,
    colno: colno,
    error: error,
  });
};

document.addEventListener("click", function (event) {
  const dom = event.target as HTMLElement;
  if (!dom) {
    return;
  }
  const clickEvent = {
    timestamp: new Date().toISOString(),
    id: dom.id,
    tagName: dom.tagName,
    classList: Array.from(dom.classList),
    innerText: dom.innerText,
    x: event.clientX,
    y: event.clientY,
  };
  log.info("[click]", clickEvent);
});

// log.debug("log debug");
// log.info("log info");
// log.warn("log warn");
// log.error("log error");

export default logger;
